import validate from "/usr/src/app/content/n3-redirections-service-2c6bc405-fbf2-401b-ac01-ab192d0ed6f7/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-service-2c6bc405-fbf2-401b-ac01-ab192d0ed6f7/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}